import React from 'react';
import PropTypes from 'prop-types';
import { injectTestId } from '@cvent/nucleus-test-automation';
import ItemElement from './ItemElement';

/* <Item />
---------------------------------------------------------------------------- */
/**
 * Stateful element accessed statically as `Pagination.Item`
 */
export default class Item extends React.Component {
  static propTypes = {
    /** aria-label or accessibilityLabel attribute */
    accessibilityLabel: PropTypes.string,
    /** aria-hidden or accessible attribute */
    accessible: PropTypes.bool,
    /** Disabled attribute */
    disabled: PropTypes.bool,
    /** Icon name */
    icon: PropTypes.string,
    /** Text direction */
    isRtl: PropTypes.bool,
    /** Text to display inside the page button */
    text: PropTypes.string,
    /** Interaction event handler */
    onPress: PropTypes.func,
    /** Selected tab */
    selected: PropTypes.bool,
    /** For e2e tests (maps to `data-cvent-id`) */
    testID: PropTypes.string
  };

  static defaultProps = {
    disabled: false,
    isRtl: false,
    accessible: true,
    selected: false
  };

  render() {
    const {
      accessibilityLabel,
      accessible,
      isRtl,
      testID,
      text,
      disabled,
      selected,
      onPress,
      icon
    } = this.props;

    return (
      <ItemElement
        accessible={accessible}
        accessibilityLabel={accessibilityLabel}
        isRtl={isRtl}
        text={text}
        disabled={disabled}
        selected={selected}
        onPress={onPress}
        icon={icon}
        {...injectTestId(testID)}
      />
    );
  }
}
